export default {
  1: 'שגיאה כללית',

  // 2: `שם משתמש קיים במערכת .
  //           <span class="primary--text pointer-underline open-login">
  //             להתחברות
  //           </span>`,
  2: 'שם משתמש קיים במערכת ',
  3: 'שגיאת רישום',
  4: 'שדה חובה',
  5: 'שם משתמש ו/או סיסמה שגויה',
  6: 'שגיאה',
  7: 'קובץ קורות חיים ----- אינו נתמך. ניתן לשלוח קובץ קורות חיים מסוג doc, docx, rtf, txt, pdf',
  8: 'שים לב! פעולה זו תגרום למחיקת הקובץ מכל המשרות אליהן שלחת קובץ זה בעבר. האם אתה רוצה להמשיך?',
  9: 'שגיאה',
  10: 'יש לבחור ישוב',
  11: 'יש להזין שנת לידה תקינה',
  12: 'שדה חובה',
  13: 'סיסמה שגויה',
  14: 'כתובת אימייל זהה לנוכחית',
  15: 'כתובת אימייל אינה תקינה',
  16: 'שגיאה',
  17: 'שגיאה',
  18: 'שגיאה',
  19: 'שגיאה',
  20: 'יש לבחור לפחות איזור אחד',
  21: 'יש לבחור קטגוריה',
  22: 'יש לבחור לפחות תחום אחד',
  23: 'שגיאת תחביר',
  24: 'מקסימום 80 תוים',
  25: 'יש להזין לפחות 6 תווים',
  26: 'פורטל דרושים אינו מאפשר שליחה של קבצי קורות חיים הגדולים מ 500 KB',
  27: 'שגיאה',
  28: 'שגיאה',
  29: 'שגיאה',
  30: 'שגיאה',
  31: 'שגיאה',
  32: 'שגיאה',
  33: 'שגיאת רישום',
  34: 'שגיאה',
  35: 'שגיאה',
  36: 'שגיאה',
  37: 'שם משתמש ו/או סיסמה שגויה',
  38: 'פג תוקף קוד איפוס סיסמה. אנא נסה שנית.',
  39: 'שגיאה',
  40: 'שגיאה',
  41: 'שגיאה',
  42: 'שגיאה',
  43: 'שגיאה',
  44: 'שגיאה',
  45: 'שגיאה',
  46: 'הגעת למכסת השליחות היומית שלך. אנא נסה לשלוח שוב מחר!',
  47: 'קובץ כבר קיים במערכת',
  48: 'לא ניתן להעלות קובץ נוסף, להחלפת קובץ לחצו',
  49: 'שגיאה',
  50: 'שגיאה',
  51: 'שגיאה',
  52: 'שגיאה',
  53: 'שגיאה',
  54: 'יש לבחור לפחות אפשרות אחת של שנות נסיון',
  55: 'יש לבחור לפחות היקף משרה אחד',
  56: 'שגיאה',
  57: 'שגיאה',
  58: 'שגיאה, יש לשנות  הגדרות חיפוש.',
}
